import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import VipOffersDashboard from '../../../MarketplaceHub/VipOffersDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyVipOffers } from './companyMarketplaceApi';

/** Company Marketplace → VIP offers dashboard, scoped to this company. */
const CMarketplaceVip = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyVipOffers(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Marketplace VIP Offers | Shoorah</title>
      </Helmet>
      <VipOffersDashboard
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CMarketplaceVip;
